"use client";

import styles from "./Button.module.scss";
import classNames from "classnames";
import { ButtonTypes } from "./Button.types";

const Button = ({
  size = "medium",
  variant = "primary",
  children,
  className = "",
  href,
  onClick = () => {},
  openInNewTab = false,
  disabled = false,
  loading = false,
  type = "button",
  startContent = null,
  endContent = null,
}: ButtonTypes) => {
  const isLink = Boolean(href);
  const HtmlTag = isLink ? "a" : "button";

  return (
    <HtmlTag
      {...(HtmlTag === "button" ? { type } : {})}
      {...(isLink && {
        href,
        target: openInNewTab ? "_blank" : undefined,
        rel: openInNewTab ? "noopener noreferrer" : undefined,
      })}
      onClick={(e) => {
        if (disabled || loading) return;
        onClick(e);
        if (!isLink) return;
      }}
      className={classNames(
        styles["comp"],
        styles[`comp--variant-${variant}`],
        styles[`comp--size-${size}`],
        startContent !== null && styles[`comp--with-start-content`],
        endContent !== null && styles[`comp--with-end-content`],
        (disabled || loading) && styles[`comp--disabled`],
        className
      )}
    >
      {startContent && startContent}
      {children}
      {endContent && endContent}

      {loading && <div className={styles["comp__loading"]} />}
    </HtmlTag>
  );
};

export { Button };
